export default "__VITE_ASSET__KPMjxFwm__"